<template>
    <div id="date-picker">
        <div class="input-group">
            <input type="text"
                   :title="title"
                   ref="datepicker"
                   class="form-control"
                   readonly="readonly"
                   :disabled="disabled"
                   :autocomplete="autoComplete"
                   :required="required"
                   :class="{ 'is-invalid' : error }"/>
            <div class="input-group-append" @click="datepicker.focus()">
                <span class="input-group-text">
                    <i class="fas fa-calendar-alt" aria-hidden="true"></i>
                </span>
            </div>
        </div>
        <small class="invalid-feedback d-block" v-show="error !== ''">
            {{ error || '' }}
        </small>
    </div>
</template>

<script>
import {onMounted, ref, watch} from 'vue';
import moment from 'moment';

export default {
    props: {
        reference: {
            type: String,
            required: false,
        },
        onChange: {
            type: Function,
            required: false,
        },
        value: {
            type: Date,
            required: false,
            default: new Date(),
        },
        title: {
            type: String,
            required: false,
        },
        extras: {
            type: Object,
            required: false,
        },
        error: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        pickerFormat: {
            type: String,
            required: false,
            default: 'dd-mm-yyyy',
        },
        dateFormat: {
            type: String,
            required: false,
            default: 'DD-MM-YYYY',
        },
        orientation: {
            type: String,
            required: false,
            default: 'bottom',
        },
        autoClose: {
            type: Boolean,
            required: false,
            default: true,
        },
        todayHighlight: {
            type: Boolean,
            required: false,
            default: true,
        },
        autoComplete: {
            type: Boolean,
            required: false,
            default: false,
        },
        viewMode: {
            type: String,
            required: false,
            default: 'days',
        },
        minViewMode: {
            type: String,
            required: false,
            default: 'days',
        },
    },
    setup(props) {
        const datepicker = ref(null);

        function format(date) {
          return date && date !== '' ? moment(date, props.dateFormat).locale('en').format(props.dateFormat) : null;
        }

        function onChange(e) {
            if (props.onChange) {
                props.onChange(props.reference, format(e.date))
            }
        }

        onMounted(() => {
            $(datepicker.value).datepicker({
                language: 'en',
                autoclose: props.autoClose,
                format: props.pickerFormat,
                orientation: props.orientation,
                viewMode: props.viewMode,
                minViewMode: props.minViewMode,
                todayHighlight: props.todayHighlight,
                clearBtn: !props.required,
                ...props.extras,
            }).on('changeDate', e => onChange(e))
            datepicker.value.value = format(props.value)
            onChange({ date: props.value })
        })

        const value = ref(props.value);
        watch(value, newVal => $(datepicker.value).datepicker('update', format(newVal)))

        return {
            datepicker,
            value,
            onChange,
        }
    },
    methods: {
        forceUpdate() {
            const datepicker = $(this.$refs.datepicker)
            datepicker.datepicker('destroy')
            datepicker.datepicker({
                language: 'en',
                autoclose: this.autoClose,
                format: this.pickerFormat,
                orientation: this.orientation,
                viewMode: this.viewMode,
                minViewMode: this.minViewMode,
                todayHighlight: this.todayHighlight,
                clearBtn: !this.required,
                ...this.extras,
            }).on('changeDate', e => this.onChange(e))
            datepicker.datepicker('update', this.value)
        }
    }
}
</script>

<style scoped>
#date-picker {
    min-width: 150px;
    margin: auto;
}
</style>
